import { AnimatePresence, motion } from "framer-motion";
import { Link, useLocation } from "react-router-dom";
import { X } from "lucide-react";
import { NAV_LINKS } from "@/config/site";
import { cn } from "@/lib/utils";

export const MobileNav = ({ open, onClose }) => {
  const { pathname } = useLocation();

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          data-testid="mobile-nav-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.25 }}
          className="fixed inset-0 z-50 flex flex-col bg-brand-black lg:hidden"
        >
          <div className="flex h-20 items-center justify-end px-6">
            <button
              type="button"
              data-testid="mobile-menu-close"
              aria-label="Close menu"
              onClick={onClose}
              className="p-2 text-white"
            >
              <X className="h-6 w-6" />
            </button>
          </div>
          <nav aria-label="Mobile" className="flex flex-1 flex-col justify-center gap-2 px-8">
            {NAV_LINKS.map((link, i) => {
              const active = pathname === link.path;
              return (
                <motion.div
                  key={link.path}
                  initial={{ opacity: 0, y: 16 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.08 * i, duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
                >
                  <Link
                    to={link.path}
                    onClick={onClose}
                    data-testid={`mobile-nav-${link.label.toLowerCase()}`}
                    className={cn(
                      "flex items-center gap-3 py-3 font-heading text-4xl uppercase transition-colors",
                      link.live ? "text-live-red" : active ? "text-brand-purple" : "text-white"
                    )}
                  >
                    {link.live && <span className="h-2.5 w-2.5 rounded-full bg-live-red animate-pulse" aria-hidden="true" />}
                    {link.label}
                  </Link>
                </motion.div>
              );
            })}
          </nav>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
